module.exports = __webpack_public_path__ + "img/vertical_5_1_8019.1661faf3.png";